export default {
    Oxford: "Oxford",
    Cambridge: "Cambridge",
    "Ascot, Berkshire": "St Mary's School, Ascot",
    London: "Imperial College London",
    Uppingham: "Uppingham School",
    "Yale University, USA": "Yale University",
    "UC Berkeley, USA": "UC Berkeley",
    "St Andrews, Scotland": "University of St Andrews"
};